import React, { useState } from "react";
import { METRIC_BANDS, DEFAULT_VISIBLE_BANDS, ScenarioColumnPicker } from "./columnPickerShared";

export default function NextYearForecastTab({
  classes, ContractTable, nyTotal, nyRows, fiscalYear, periodMonthKeys,
}) {
  const [visibleBands, setVisibleBands] = useState(DEFAULT_VISIBLE_BANDS);
  const toggle = (key) =>
    setVisibleBands((prev) =>
      prev.includes(key)
        ? prev.length > 1 ? prev.filter((k) => k !== key) : prev
        : [...prev, key].sort((a, b) =>
            METRIC_BANDS.findIndex((m) => m.key === a) - METRIC_BANDS.findIndex((m) => m.key === b))
    );

  const fyLabel = fiscalYear ? `FY-${fiscalYear}` : "Next Year Forecast";

  return (
    <div>
      <ContractTable title={fyLabel} totalRow={nyTotal} rows={nyRows}
        classes={classes} year={String(fiscalYear || "")} visibleBands={visibleBands}
        controls={<ScenarioColumnPicker visible={visibleBands} onToggle={toggle} />} periodMonthKeys={periodMonthKeys} />
    </div>
  );
}
